export default {
  getApply: 'distributor/manager/getregisterapply', // 获取申诉
  untieApply: 'distributor/manager/unbound', // 解绑申诉
  feedback: 'distributor/manager/getfeedback',
  getTeacherInfo: 'distributor/manager/teacher/info',
  delStudent: 'gaozhong/weici/group/class/student/del', // 删除班级学生
  appleInfo: 'distributor/manager/getallappleinfo',
  appleDetail: 'distributor/manager/getappleinfobyid',
  dealApple: 'distributor/manager/updateapple',
  registerInfo: 'distributor/report/register'
}



// WEBPACK FOOTER //
// ./src/service/Api.js